'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { SetupSidebar, SetupSidebarProps } from '@/components/SetupSidebar'
import { SetupSteps } from '@/components/SetupSteps'
import { SetupStepsProps } from '@/components/SetupSteps'

export const StoreSetupClient: React.FC<{
  heading: string
  daemon: string
  links: SetupSidebarProps['links']
  steps: SetupStepsProps['steps']
}> = ({ heading, daemon, links, steps }) => {
  return (
    <Section bgClassName="bg-paper-2">
      <div className="flex flex-col xl:flex-row justify-between gap-[50px]">
        <SetupSidebar heading={heading} daemon={daemon} links={links} />
        <SetupSteps steps={steps} />
      </div>
    </Section>
  )
}
